import React from 'react';
import { tFn } from '../i18n';

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Global error boundary caught an error:', error, errorInfo);
  }

  handleBackToLobby = () => {
    window.location.assign(window.location.origin);
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const { t } = this.props;

    return (
      <div
        role="alert"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          background: 'linear-gradient(135deg, #0b1220 0%, #1f2a44 52%, #173b4f 100%)',
          color: '#e5edf8',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '520px',
            borderRadius: '16px',
            border: '1px solid rgba(148, 163, 184, 0.35)',
            background: 'rgba(15, 23, 42, 0.72)',
            boxShadow: '0 20px 60px rgba(2, 6, 23, 0.55)',
            padding: '24px',
          }}
        >
          <h1 style={{ margin: 0, marginBottom: '10px', fontSize: '26px', fontWeight: 700 }}>
            {t('appErrorTitle')}
          </h1>
          <p style={{ margin: 0, marginBottom: '18px', color: '#bfdbfe', lineHeight: 1.6 }}>
            {t('appErrorBody')}
          </p>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={this.handleBackToLobby}
              style={{
                borderRadius: '10px',
                border: '1px solid rgba(56, 189, 248, 0.45)',
                background: 'rgba(14, 116, 144, 0.25)',
                color: '#e0f2fe',
                fontWeight: 700,
                minHeight: '44px',
                padding: '0 14px',
                cursor: 'pointer',
              }}
            >
              {t('appErrorBackToLobby')}
            </button>
            <button
              type="button"
              onClick={this.handleReload}
              style={{
                borderRadius: '10px',
                border: '1px solid rgba(139, 92, 246, 0.55)',
                background: 'rgba(91, 33, 182, 0.32)',
                color: '#f3e8ff',
                fontWeight: 700,
                minHeight: '44px',
                padding: '0 14px',
                cursor: 'pointer',
              }}
            >
              {t('appErrorReload')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const ErrorBoundary = ({ children }) => {
  const language = localStorage.getItem('kosteczki_lang') || 'en';
  const t = (key, fallback) => tFn(language, key, fallback);
  return <ErrorBoundaryInner t={t}>{children}</ErrorBoundaryInner>;
};

export default ErrorBoundary;
